import React, { useMemo } from 'react';

// Ambient decorative background: floating clouds, stars, balloons, bubbles.
const CLOUDS = [
  { top: '8%', left: '6%', size: 90, delay: 0 },
  { top: '14%', left: '72%', size: 120, delay: 1.5 },
  { top: '60%', left: '4%', size: 70, delay: 0.8 },
  { top: '72%', left: '80%', size: 100, delay: 2.2 },
];

const STARS = [
  { top: '22%', left: '20%', size: 26, color: '#FBBF24', delay: 0 },
  { top: '10%', left: '46%', size: 18, color: '#F472B6', delay: 0.6 },
  { top: '40%', left: '88%', size: 22, color: '#34D399', delay: 1.1 },
  { top: '80%', left: '32%', size: 20, color: '#60A5FA', delay: 0.3 },
  { top: '54%', left: '60%', size: 16, color: '#C084FC', delay: 1.7 },
  { top: '30%', left: '8%', size: 16, color: '#FB7185', delay: 2 },
];

function Cloud({ top, left, size, delay }) {
  return (
    <div
      className="absolute anim-floaty-slow"
      style={{ top, left, width: size, animationDelay: `${delay}s` }}
      aria-hidden
    >
      <svg viewBox="0 0 120 70" width={size} height={(size * 70) / 120}>
        <g fill="#ffffff" opacity="0.85">
          <circle cx="35" cy="40" r="24" />
          <circle cx="60" cy="30" r="28" />
          <circle cx="88" cy="42" r="22" />
          <rect x="30" y="40" width="62" height="24" rx="12" />
        </g>
      </svg>
    </div>
  );
}

function Star({ top, left, size, color, delay }) {
  return (
    <div
      className="absolute anim-floaty"
      style={{ top, left, animationDelay: `${delay}s` }}
      aria-hidden
    >
      <svg width={size} height={size} viewBox="0 0 24 24" fill={color}>
        <path d="M12 2l2.9 6.3 6.9.7-5.1 4.6 1.4 6.8L12 17.8 5.9 20.4 7.3 13.6 2.2 9l6.9-.7z" />
      </svg>
    </div>
  );
}

export function Background({ children }) {
  const clouds = useMemo(() => CLOUDS, []);
  const stars = useMemo(() => STARS, []);
  return (
    <div className="sky-bg relative w-full overflow-hidden">
      <div className="pointer-events-none absolute inset-0 z-0">
        {clouds.map((c) => (
          <Cloud key={`cloud-${c.top}-${c.left}`} {...c} />
        ))}
        {stars.map((s) => (
          <Star key={`star-${s.top}-${s.left}`} {...s} />
        ))}
        {/* soft green hills at the bottom */}
        <svg
          className="absolute bottom-0 left-0 w-full"
          viewBox="0 0 1440 220"
          preserveAspectRatio="none"
          height="180"
          aria-hidden
        >
          <path
            d="M0 160 C 240 90 480 90 720 140 C 960 190 1200 120 1440 150 L1440 220 L0 220 Z"
            fill="#86efac"
            opacity="0.7"
          />
          <path
            d="M0 190 C 300 150 600 150 900 180 C 1140 200 1320 170 1440 185 L1440 220 L0 220 Z"
            fill="#4ade80"
            opacity="0.8"
          />
        </svg>
      </div>
      <div className="relative z-10">{children}</div>
    </div>
  );
}
